export default __webpack_public_path__ + "static/media/icon_social-twitter.07d439f6.svg";